import { FC, memo } from 'react'

import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'

import * as SC from '../../../styles'

export interface FooterProps {
  onSubmit?: () => void
  onCancel: () => void
  isSubmitting: boolean
}

export const Footer: FC<FooterProps> = memo((props) => {
  const { onCancel, onSubmit, isSubmitting = false } = props

  return (
    <SC.Box>
      <ButtonGroup margin="small">
        <Button loading={isSubmitting} face="primary" onClick={onSubmit}>
          Submit
        </Button>
        <Button face="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </ButtonGroup>
    </SC.Box>
  )
})
